"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBondInterface = exports.isEthernetInterface = exports.isVlanInterface = exports.NmstateInterfaceType = void 0;
var NmstateInterfaceType;
(function (NmstateInterfaceType) {
    NmstateInterfaceType["ETHERNET"] = "ethernet";
    NmstateInterfaceType["VLAN"] = "vlan";
    NmstateInterfaceType["BOND"] = "bond";
})(NmstateInterfaceType = exports.NmstateInterfaceType || (exports.NmstateInterfaceType = {}));
const isVlanInterface = (nmStateInterface) => {
    return nmStateInterface.type === NmstateInterfaceType.VLAN;
};
exports.isVlanInterface = isVlanInterface;
const isEthernetInterface = (nmStateInterface) => {
    return nmStateInterface.type === NmstateInterfaceType.ETHERNET;
};
exports.isEthernetInterface = isEthernetInterface;
const isBondInterface = (nmStateInterface) => {
    return nmStateInterface.type === NmstateInterfaceType.BOND;
};
exports.isBondInterface = isBondInterface;
//# sourceMappingURL=nmstateTypes.js.map